import { CATEGORIES, CATEGORY_LABELS, CATEGORY_STATS_LABELS } from "@/constants/categories";

// CategoryStatsModal - Zeigt abgeschlossene Taten pro Kategorie
const CategoryStatsModal = ({ 
  category, // null wenn geschlossen
  language,
  categoryStats,
  completedDeeds, // Array von {date, formattedDate, text}
  t,
  onClose 
}) => {
  if (!category) return null;
  
  const config = CATEGORIES[category];
  const Icon = config?.icon;
  
  return (
    <div className="notification-prompt-overlay" data-testid="category-stats-overlay">
      <div className="notification-prompt category-stats-modal">
        <div className="category-stats-header">
          <div className="category-stats-icon" style={{ color: config?.color }}>
            {Icon && <Icon size={24} />}
          </div>
          <h3>{CATEGORY_LABELS[category]?.[language]}</h3>
          <span className="category-stats-count">{categoryStats[category]}/7</span>
        </div>
        
        <div className="category-stats-content">
          {completedDeeds.length > 0 ? (
            <table className="category-deeds-table">
              <thead>
                <tr>
                  <th>{CATEGORY_STATS_LABELS[language]?.date || 'Datum'}</th>
                  <th>{CATEGORY_STATS_LABELS[language]?.deed || 'Tat'}</th>
                </tr>
              </thead>
              <tbody>
                {completedDeeds.map((deed) => (
                  <tr key={deed.date}>
                    <td className="deed-date">{deed.formattedDate}</td>
                    <td className="deed-text-cell">{deed.text}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="no-deeds-message">
              {CATEGORY_STATS_LABELS[language]?.noDeeds || 'Noch keine Taten in dieser Kategorie'}
            </p>
          )}
        </div>
        
        <button 
          className="prompt-btn primary" 
          onClick={onClose} 
          data-testid="close-category-stats"
        >
          {t.postDeedDone || 'Fertig'}
        </button>
      </div>
    </div>
  );
};

export default CategoryStatsModal;
